import './Loader.scss';
import 'react-circular-progressbar/dist/styles.css';

import {Box, Container, Text, VStack} from "@chakra-ui/react";
import {CircularProgressbar, buildStyles} from "react-circular-progressbar";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {FormattedMessage} from "react-intl";

function Loader() {
    let [percentage, setPercentage] = useState(0);
    let navigate = useNavigate();

    useEffect(() => {
        if (percentage === 100) {
            navigate('../complete', {replace: true});
        }

        if (percentage < 100) {
            const interval = setInterval(() => {
                setPercentage(percentage => percentage + 10);
            }, 200);
            return () => clearInterval(interval);
        }
    }, [percentage, navigate]);

    return (
        <Container display={'flex'} height={'80%'} alignItems={'center'} justifyContent={'center'}>
            <VStack background={'#fff'} p={5} borderRadius="lg">
                <Box width={200} height={200} mb={5}>
                    <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        styles={buildStyles({
                            pathColor: `rgba(231, 75, 85, ${percentage / 100})`,
                            textColor: "#e74b55"
                        })}
                    />
                </Box>
                <Text px={30} fontSize={'large'} fontWeight={'bold'} textAlign={'center'}>
                    <FormattedMessage id="loader" />
                </Text>
            </VStack>
        </Container>
    )
}

export default Loader;
